<template>
  <footer class="footer footer-transparent d-print-none">
    <div class="container-xl">
      <div class="row text-center align-items-center flex-row-reverse">
        <div class="col-12 col-lg-auto mt-3 mt-lg-0">
          <ul class="list-inline list-inline-dots mb-0">
            <li class="list-inline-item">
              Copyright © 2024
              <a href="." class="link-secondary">SUMSG</a>.
              All rights reserved.
            </li>
            <li class="list-inline-item">
              v1.0.0
            </li>
            <li class="list-inline-item">
              <a href="/destroy_account">删除账户</a>
            </li>
            <li class="list-inline-item">
              <a href="https://www.github.com/sumsg/sumsg-demo-js" target="_blank">开放文档</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<style scoped>
.footer .list-inline-item a {
  color: var(--tblr-secondary);
}
</style>